export function formatDebugValue(value) {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value, null, 2);
  }
  return String(value);
}

export function parseDefaultTestAmount(moneyGz) {
  const gz = moneyGz ? String(moneyGz) : '';
  const match = gz.match(/(\d+(?:\.\d+)?)/);
  if (match) {
    const val = parseFloat(match[1]);
    return val > 0 ? val : 100;
  }
  return 100;
}
